import { Accordion, Table } from 'react-bootstrap';

function AllCollapseExample(props) {
  const amountOwed = parseFloat(props.payDue) || 0;
  const amountPaid = parseFloat(props.amountPaid) || 0;
  const outstandingBalance = parseFloat(props.outstandingBalance) || 0;

  return (
    <>
      {/* Ensure defaultActiveKey matches one of the eventKey values */}
      <Accordion defaultActiveKey={null}>
        <Accordion.Item eventKey={props.eventKey || '0'}>
          <Accordion.Header>
            <div className="col border-color-red">
              <div className="mb-0 h-5">{props.name}</div>
              <div>
                <p className="mb-0">{props.projectName}</p>
                <br />
                <p className="mb-0">{props.invoiceDate}</p>
                <br />
                <p className="mb-0">{props.invoiceNumber}</p>
              </div>
            </div>
            {props.status ? (
              <div
                className="col pt-3"
                style={{
                  width: 'max-content',
                  float: 'right',
                  textAlign: 'right',
                  paddingRight: '10px',
                }}
              >
                <p className="mb-0" style={{ display: 'block' }}>Invoice total: <strong>${amountOwed.toFixed(2)}</strong></p>
                <p className="mb-0" style={{ display: 'block' }}>Amount Paid: <strong>${amountPaid.toFixed(2)}</strong></p>
                <p className="mb-0" style={{ display: 'block', color: outstandingBalance > 0 ? 'red' : 'inherit' }}>Outstanding Balance: <strong>${outstandingBalance.toFixed(2)}</strong></p>
              </div>
            ) : (
              ''
            )}
          </Accordion.Header>
          <Accordion.Body>
            {props.comp}
            {props.pays ? (
              props.pays.length > 0 ? (
                <Table striped bordered hover>
                  <thead className="text-center">
                    <tr>
                      <th>Date Paid</th>
                      <th>Amount Paid</th>
                      <th>Pay Type</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {props.pays.map((pay, index) => (
                      <tr key={pay.datePaid || index}>
                        <td>{pay.datePaid}</td>
                        <td>${parseFloat(pay.pay).toFixed(2)}</td>
                        <td>{pay.payType}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                ''
              )
            ) : (
              ''
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default AllCollapseExample;